import React from 'react'
import { Link } from 'react-router-dom'

 const Navbar = () => {
    return (
      <div>
         <nav className="navbar navbar-expand-lg bg-dark"  style={{position: 'fixed',top: '0px', left: '0px',width: '100%', zIndex: 10}}>
            <div className="container-fluid">
                <Link className="navbar-brand text-light" to="/General">News</Link>
                <button className="navbar-toggler"  type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon" style= {{color: "white"}}></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                  
                    <li className="nav-item mx-2"><Link className="nav-link active text-light" to="/General" >General</Link></li>
                    <li className="nav-item mx-2"><Link className="nav-link active text-light" to="/Entertainment" >Entertainment</Link></li>
                    <li className="nav-item mx-2"><Link className="nav-link active text-light" to="/Sports" >Sports</Link></li>
                    <li className="nav-item mx-2"><Link className="nav-link active text-light" to="/Science">Science</Link></li>
                    <li className="nav-item mx-2"><Link className="nav-link active text-light" to="/Health" >Health</Link></li>
                    <li className="nav-item mx-2"><Link className="nav-link active text-light" to="/Business" >Business</Link></li>
                    <li className="nav-item mx-2"><Link className="nav-link active text-light" to="/Technology" >Technology</Link></li>

                </ul>
                </div>
            </div>
         </nav>
      </div>
    )
  
}

export default Navbar;


